<script setup>
/**
 * Lista de campañas (Live-chat, SMS, WhatsApp-CSV…).
 * Propaga los eventos:
 *   • edit(campaign)
 *   • delete(campaign)
 *   • stats(campaign)   ← NUEVO
 */

import CampaignCard from 'dashboard/components-next/Campaigns/CampaignCard/CampaignCard.vue';
import { INBOX_TYPES } from 'dashboard/helper/inbox';
import { useConfig } from 'dashboard/composables/useConfig';

defineProps({
  campaigns: { type: Array, required: true },
  isLiveChatType: { type: Boolean, default: false },
  enableStats: { type: Boolean, default: false },
});

const emit = defineEmits(['edit', 'delete', 'stats', 'analytics']);
const ANALYTICS_CAMPAIGN_STATUSES = ['processing', 'completed'];
const { isEnterprise } = useConfig();

const handleEdit = campaign => emit('edit', campaign);
const handleDelete = campaign => emit('delete', campaign);
const handleStats = campaign => emit('stats', campaign);
const handleAnalytics = campaign => emit('analytics', campaign);
</script>

<template>
  <div class="flex flex-col gap-4">
    <CampaignCard
      v-for="campaign in campaigns"
      :key="campaign.id"
      :title="campaign.title"
      :message="campaign.message"
      :template="campaign.template"
      :is-enabled="campaign.enabled"
      :status="campaign.campaign_status"
      :sender="campaign.sender"
      :inbox="campaign.inbox"
      :scheduled-at="campaign.scheduled_at"
      :is-live-chat-type="isLiveChatType"
      :show-stats="enableStats"
      :show-analytics="
        !enableStats &&
        isEnterprise &&
        campaign.inbox?.channel_type === INBOX_TYPES.WHATSAPP &&
        ANALYTICS_CAMPAIGN_STATUSES.includes(campaign.campaign_status)
      "
      @edit="handleEdit(campaign)"
      @delete="handleDelete(campaign)"
      @stats="handleStats(campaign)"
      @analytics="handleAnalytics(campaign)"
    />
  </div>
</template>
